import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getGatewayList(actions) {
  let uuid = actions.idUser ? actions.idUser : getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/payment/gateways";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "LIST_GATEWAYS_RESPONSE", value: response });
    return response;
  } catch (error) {

    yield put({
      type: "PAYMENT_API_ERROR",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getPartnerList(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/payment/partners${actions.query || ""}`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status === "success") {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "LIST_PARTNERS_RESPONSE",
      value: { ...response, responseStatus },
    });
    return response;
  } catch (error) {
    yield put({
      type: "PAYMENT_API_ERROR",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* createPartner(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/payment/partners";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "post", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response?.result?.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "GET_PARTNERS_LIST",
      access: actions.access,
      params: actions.params,
    });

    yield put({
        type: "GET_CREATED_PARTNER_DETAILS",
        value: {...response, responseStatus}
    });
    return response;
    } catch (error) {
    yield put({
      type: "PAYMENT_API_ERROR",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* initializedProfile(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/payment/profiles/initialise";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "post", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status === "success") {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "SET_PROFILE_CREATION_IFRAME_TOKEN",
      value: { ...response, responseStatus },
    });
    return response;
  } catch (error) {

    yield put({
      type: "SET_PROFILE_CREATION_IFRAME_TOKEN",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getPaymentProfileList(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/payment/profiles${actions.params || ""}`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status === "success") {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "LIST_PAYMENT_PROFILE_RESPONSE",
      value: { ...response, responseStatus },
    });
    return response;
  } catch (error) {
    yield put({
      type: "PAYMENT_API_ERROR",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getPaymentProfileDetails(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/payment/profiles/"+ actions.profileId;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status === "success" ) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "GET_PAYMENT_PROFILE_DETAILS",
      value: { ...response, responseStatus },
    });
    return response;
} catch (error) {
    yield put({
      type: "PAYMENT_API_ERROR",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* createPaymentProfile(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/payment/profiles";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "post", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response?.result?.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "GET_PAYMENT_PROFILE_LIST",
      access: actions.access,
      params: actions.params,
    });

    yield put({
      type: "GET_PAYMENT_PROFILE_CREATED",
      value: { ...response, responseStatus },
    });

    return response;
    } catch (error) {
    yield put({
      type: "PAYMENT_API_ERROR",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* updatePaymentProfile(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/payment/profiles/"+ actions.profileId;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response?.result?.updatedAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "GET_PAYMENT_PROFILE_LIST",
      access: actions.access,
      params: actions.params,
    });

    yield put({
      type: "PAYMENT_PROFILE_UPDATE",
      value: { ...response, responseStatus },
    });
    return response;
    } catch (error) {
    yield put({
      type: "PAYMENT_API_ERROR",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* deletePaymentProfile(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/payment/profiles/"+ actions.profileId;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "delete", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status === "success") {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "GET_PAYMENT_PROFILE_LIST",
      access: actions.access,
      params: actions.params,
    });
    return response;
  } catch (error) {
    yield put({
      type: "PAYMENT_API_ERROR",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

export function* getSagaGatewayList() {
  yield takeEvery("GET_GATEWAY_LIST", getGatewayList);
}

export function* getSagaPartnersList() {
  yield takeEvery("GET_PARTNERS_LIST", getPartnerList);
}

export function* createSagaPartner() {
  yield takeEvery("CREATE_PARTNER", createPartner);
}

export function* initializedSagaProfile() {
  yield takeEvery("INITIALIZED_PROFILE", initializedProfile);
}

export function* getSagaPaymentProfileList() {
  yield takeEvery("GET_PAYMENT_PROFILE_LIST", getPaymentProfileList);
}

export function* getSagaPaymentProfileDetails() {
  yield takeEvery("GET_PAYMENT_PROFILE_DETAILS", getPaymentProfileDetails);
}

export function* createSagaPaymentProfile() {
  yield takeEvery("CREATE_PAYMENT_PROFILE", createPaymentProfile);
}

export function* updateSagaPaymentProfile() {
  yield takeEvery("UPDATE_PAYMENT_PROFILE", updatePaymentProfile);
}

export function* deleteSagaPaymentProfile() {
  yield takeEvery("DELETE_PAYMENT_PROFILE", deletePaymentProfile);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};